export var getTerminatorSuggestion = function (term, experiments) {
    var matchingSuggestion = terminatorSuggestions.find(function (suggestion) {
        return suggestion.terms
            .map(function (sTerm) { return sTerm.toLowerCase(); })
            .includes(term.toLowerCase()) &&
            (experiments.enabled(suggestion.spec) || !suggestion.spec);
    });
    return matchingSuggestion || null;
};
var terminatorSuggestions = [
    {
        terms: [
            'Wedding',
            'wedding registry',
            'gift registry',
            'gifts',
            'Zola',
            'Gift',
            'Registry',
        ],
        titleKey: 'terminator.suggestions-weddings-title',
        descriptionKey: 'terminator.suggestions-weddings-description',
        ctaUrl: 'https://support.wix.com/en/article/adding-gift-registries-to-your-wedding-website',
        iconUrl: 'suggestion-weddings.svg',
        spec: '',
    },
    {
        terms: ['Content', 'Writer', 'write', 'writing'],
        titleKey: 'terminator.suggestions-writing-solutions-title',
        descriptionKey: 'terminator.suggestions-writing-solutions-description',
        ctaUrl: 'https://www.wix.com/experts/content-writers',
        iconUrl: 'suggestion-marketing-manager.jpg',
        spec: '',
    },
    {
        terms: ['html', 'iframe', 'html iframe', 'html code'],
        titleKey: 'terminator.suggestions-html-solutions-title',
        descriptionKey: 'terminator.suggestions-html-solutions-description',
        ctaUrl: 'https://support.wix.com/en/article/using-iframes-to-display-visible-content-on-your-site#adding-html-content',
        iconUrl: '',
        spec: '',
    },
    {
        terms: ['google maps', 'google map'],
        titleKey: 'terminator.suggestions-google-maps-solutions-title',
        descriptionKey: 'terminator.suggestions-google-maps-solutions-description',
        ctaUrl: 'https://support.wix.com/en/article/adding-and-setting-up-google-maps',
        iconUrl: '',
        spec: '',
    },
    {
        terms: ['whatsapp', 'whatsapp chat'],
        titleKey: 'terminator.suggestions-whatsapp-solutions-title',
        descriptionKey: 'terminator.suggestions-whatsapp-solutions-description',
        ctaUrl: 'https://support.wix.com/en/article/adding-a-link-to-whatsapp-on-your-site',
        iconUrl: '',
        spec: '',
    },
    {
        terms: ['shoutout'],
        titleKey: 'terminator.suggestions-shoutout-solutions-title',
        descriptionKey: 'terminator.suggestions-shoutout-solutions-description',
        ctaUrl: 'https://support.wix.com/en/article/accessing-your-email-marketing-dashboard',
        iconUrl: '',
        spec: '',
    },
    {
        terms: ['velo', 'code', 'javascript', 'dev mode', 'js', 'jquery'],
        titleKey: 'terminator.suggestions-corvid-solutions-title',
        descriptionKey: 'terminator.suggestions-corvid-solutions-description',
        ctaUrl: 'https://support.wix.com/en/article/about-corvid-by-wix#to-enable-corvid-on-your-site',
        iconUrl: '',
        spec: '',
    },
    {
        terms: ['zoom'],
        titleKey: 'terminator.suggestions-zoom-solutions-title',
        descriptionKey: 'terminator.suggestions-zoom-solutions-description',
        ctaUrl: 'https://support.wix.com/en/article/creating-an-online-service-via-zoom-in-wix-bookings',
        iconUrl: '',
        spec: '',
    },
    {
        terms: [
            'GDPR',
            'Cookies',
            'cookie',
            'Cookie Banner',
            'Cookie Consent',
            'Cookie Consent Banner',
            'Data Protection',
            'Data Regulations',
            'Privacy',
        ],
        titleKey: 'terminator.suggestions-privacy-center-title',
        descriptionKey: 'terminator.suggestions-privacy-center-description',
        ctaUrl: "https://www.wix.com/dashboard/msid/cookie-consent-settings-app/?referralInfo=app-market",
        iconUrl: 'suggestion-privacy.svg',
        spec: '',
        regex: 'msid',
        ctaUrlFallback: 'https://support.wix.com/en/article/displaying-a-cookie-banner-on-your-site',
    },
];
export var getCtaUrl = function (suggestion, param) {
    var regex = suggestion.regex, ctaUrl = suggestion.ctaUrl, ctaUrlFallback = suggestion.ctaUrlFallback;
    if (regex && ctaUrl.includes(regex)) {
        return param ? ctaUrl.replace(regex, param) : ctaUrlFallback;
    }
    return ctaUrl;
};
//# sourceMappingURL=terminator-data.js.map